function AlertLink(props) {
return (
<div className= {props.linkUrl}> {props.linkName}</div>
)
}

export default AlertLink;